/* tslint:disable */
/* eslint-disable */
/**
 * Generated by OpenAPI Generator (https://openapi-generator.tech)
 *
 * Do not edit manually.
 */


/**
 * 
 * @export
 */
export const DefaultAdminPermission = {
    VIEW_WORKSPACE_INFO: 'view:workspace_info',
    VIEW_USAGE_DASHBOARD: 'view:usage_dashboard',
    VIEW_USAGE_DASHBOARD_V2: 'view:usage_dashboard_v2',
    READ_WORKSPACE_HISTORY: 'read:workspace_history',
    DELETE_WORKSPACE_HISTORY: 'delete:workspace_history',
    CLIENT_ADMIN_VIEW_USERS: 'client_admin:view_users',
    CLIENT_ADMIN_ADD_USERS: 'client_admin:add_users',
    ADMIN_TERRITORY: 'admin:territory',
    CREATE_WORKSPACE_LIBRARY_ITEMS: 'create:workspace_library_items',
    CLIENT_ADMIN_INTEGRATIONS: 'client_admin:integrations',
    CLIENT_ADMIN_MANAGE_SHARING: 'client_admin:manage_sharing',
    CLIENT_ADMIN_REMOVE_USERS: 'client_admin:remove_users',
    CLIENT_ADMIN_SELF_SERVE_PERMS_READONLY: 'client_admin:self_serve_perms_readonly',
    USE_KNOWLEDGE_BASE_PROJECT: 'use:knowledge_base_project',
    CREATE_KNOWLEDGE_BASE_PROJECT: 'create:knowledge_base_project',
    VIEW_VAULT_WORKSPACE_PROJECTS: 'view:vault_workspace_projects',
    MODIFY_WORKSPACE_PROJECTS: 'modify:workspace_projects',
    READ_WORKSPACE_VAULT: 'read:workspace_vault'
} as const;
export type DefaultAdminPermission = typeof DefaultAdminPermission[keyof typeof DefaultAdminPermission];


export function instanceOfDefaultAdminPermission(value: any): boolean {
    for (const key in DefaultAdminPermission) {
        if (Object.prototype.hasOwnProperty.call(DefaultAdminPermission, key)) {
            if (DefaultAdminPermission[key as keyof typeof DefaultAdminPermission] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DefaultAdminPermissionFromJSON(json: any): DefaultAdminPermission {
    return DefaultAdminPermissionFromJSONTyped(json, false);
}

export function DefaultAdminPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefaultAdminPermission {
    return json as DefaultAdminPermission;
}

export function DefaultAdminPermissionToJSON(value?: DefaultAdminPermission | null): any {
    return value as any;
}

export function DefaultAdminPermissionToJSONTyped(value: any, ignoreDiscriminator: boolean): DefaultAdminPermission {
    return value as DefaultAdminPermission;
}

